'use strict';

import RouterStore from '../stores/RouterStore';

/**
 * Provides exact same functionality to react-router's ActiveState mixin
 * but without relying on context propagation that breaks shouldComponentUpdate:
 *
 * https://github.com/rackt/react-router/issues/470
 * https://github.com/facebook/react/issues/2517
 */
const RouterStateMixin = {
  getRouterState() {
    return {
      routerState: RouterStore.getRouterState()
    };
  },

  getInitialState() {
    return this.getRouterState();
  },

  componentWillMount() {
    RouterStore.addChangeListener(this.handleRouterStateChange);
  },

  componentWillUnmount() {
    RouterStore.removeChangeListener(this.handleRouterStateChange);
  },

  handleRouterStateChange() {
    this.setState(this.getRouterState());
  }
};

export default RouterStateMixin;


/** WEBPACK FOOTER **
 ** ./mixins/RouterStateMixin.js
 **/